// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type GoogleDriveLogoSvgrepoComsvgIconProps =
  React.ComponentProps<"svg"> & {
    title?: string;
  };

export function GoogleDriveLogoSvgrepoComsvgIcon(
  props: GoogleDriveLogoSvgrepoComsvgIconProps
) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      viewBox={"0 -96.53 1443.061 1443.061"}
      height={"1em"}
      width={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fill={"#3777e3"}
        d={"M240.525 1249.993l240.492-416.664h962.044l-240.514 416.664z"}
      ></path>

      <path
        fill={"#ffcf63"}
        d={"M962.055 833.329h481.006L962.055 0H481.017z"}
      ></path>

      <path
        fill={"#11a861"}
        d={"M0 833.329l240.525 416.664 481.006-833.328L481.017 0z"}
      ></path>
    </svg>
  );
}

export default GoogleDriveLogoSvgrepoComsvgIcon;
/* prettier-ignore-end */
